// extracted by mini-css-extract-plugin
export default {"root":"ContentLoader_root__demZg","header":"ContentLoader_header__0+tlw","loaderWrapper":"ContentLoader_loaderWrapper__KB7ZV","loaderContent":"ContentLoader_loaderContent__+d-tS"};